import { render, staticRenderFns } from "./Tx.vue?vue&type=template&id=7310b481"
import script from "./Tx.vue?vue&type=script&lang=ts"
export * from "./Tx.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports